import Client from './client';

export default class SessionCountries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/session/countries`, options);
  }

  putByCountry(organization, country, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/session/countries/${country}`, {
      ...options,
       method: 'PUT',
    });
  }

}
